module.exports = __webpack_public_path__ + "img/format_1.d0e55123.png";